
$models.login = {
	
	cachedMyUserDetails : '',
	
	getAuth : function($username, $password, $callbackSuccess, $callbackFailure) {
		$models.all.getDataFromAPI('tokens.json', 'user_email='+encodeURIComponent($username)+'&password='+encodeURIComponent($password)+'&expiry_period=86400', $callbackSuccess, $callbackFailure, 'POST', 'token');
	},
	
	getMyUserDetails : function($callback) {
		if ($models.login.cachedMyUserDetails) {
			$callback($models.login.cachedMyUserDetails);
		} else {
			$models.all.getDataFromAPI('users/me.json', '', $callback, function($error) {
				$controllers.accountsetup.display();
				$soupmail.notification.error($error.error, 'Unable to load your account.  Please ensure your account has been activated (check your email account and look for an activation email)');
			}, 'GET', 'generic', false, '', false);
		}
	},
	
	getTeamid : function() {
		return ($models.login.cachedMyUserDetails.user.team.id);
	},
	
	getUserid : function() {
		return ($models.login.cachedMyUserDetails.user.id);
	},
	
	getFullName : function() {
		return ($models.login.cachedMyUserDetails ? ($models.login.cachedMyUserDetails.user.first_name + ' ' + $models.login.cachedMyUserDetails.user.last_name) : $models.login.getUsername());
	},
	
	getUsername : function() {
// TODO :: look at possibly removing the cookie aspect of this line, for security reasons ::
		return ($models.all.current_username ? $models.all.current_username : jQuery.cookie('username'));
	},
	
	setUsername : function($username) {
		$models.all.current_username = $username;
		jQuery.cookie('username', $username, { expires: 14 });
	},
	
	getEmailAddress : function() {
		return $models.login.getUsername();
	},
	
	getToken : function() {
		if (!$models.all.current_token) {
			$models.all.current_token = jQuery.cookie('soup_standalone');
		}
		return $models.all.current_token;
	},
	
	setToken : function($token, $options) {
		if ($config.testMode) { $token = $config.fakeTestToken; }
		$options = ($options || {});
		$models.all.current_token = $token;
		jQuery.cookie('soup_standalone', $token, $options);
	},
	
	hasAdminPrivileges : function() {
		return ($models.login.cachedMyUserDetails.user.admin);
	},
	
	hasEmailTagEditingPrivileges : function($folder_owner, $email_owner) {
		if ($models.login.hasAdminPrivileges()) { return true; }
		if ($models.login.getEmailAddress() == $folder_owner) { return true; }
		if ($models.login.getEmailAddress() == $email_owner) { return true; }
		return false;
	},
	
	hasSyncEnabled : function() {
		return ($models.login.cachedMyUserDetails.user.sync_enabled);
	},
	
	hasMatchingEmailDomain : function(emailAddress) {
		return ($soupmail.string.extractEmailDomain(emailAddress) == $soupmail.string.extractEmailDomain($models.login.getEmailAddress()));
	},
	
	logout : function($apiRequestRequired, $cookieChangeRequired) {
		if ($apiRequestRequired !== false) {
			$models.all.getDataFromAPI('tokens.json', '', function() {}, null, 'DELETE');
		}
		if ($cookieChangeRequired !== false) {
			$models.login.setToken('');
		} else {
			$models.all.current_token = '';
		}
	},
	
	setCachedDetails : function($data) {
		jQuery.each($data, function($key, $val) {
			$models.login.cachedMyUserDetails.user[$key] = $val;
		});
	}
	
}



// WEBPACK FOOTER //
// ./src/js/models/authentication.js